<div class="w-full">
  <section class="px-3 md:px-6">
    <gx-section-title [title]="'error.oops' | translate" />
    <h3 id="primary-heading">{{ 'error.no_factsheet.subtitle' | translate }}</h3>
    <p class="text-lg">{{ 'error.no_factsheet.text' | translate }}</p>
  </section>
</div>
